import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';
import http from '../helpers/http';

const LogHistory = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    listBySchool: async (schoolId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/log-history/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
  };
};

export default LogHistory;
